// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import InfosLabel, { InfosLabelTypes } from '../InfosLabel';

const Wrapper = styled.div`
  padding: 0;
`;

const StyledInfosLabel = styled(InfosLabel)`
  border-radius: 1em;
`;

type PromoDisplayerProps = {
  texts?: string | null;
  warnings?: Array<string>;
  className?: string;
};

const PromoDisplayer = ({ className = '', texts = '', warnings = [] }: PromoDisplayerProps) => (
  <Wrapper className={className}>
    {[{ content: texts, isWarning: false }, ...warnings.map((warning) => ({ content: warning, isWarning: true }))].map(
      ({ content, isWarning }, index) => {
        if (content) {
          return (
            <StyledInfosLabel
              key={`promo-displayer-${index}`}
              label={content}
              symbol={isWarning ? '!' : undefined}
              type={isWarning ? InfosLabelTypes.INFOS_YELLOW : InfosLabelTypes.INFOS_GREY}
            />
          );
        }
        return null;
      },
    )}
  </Wrapper>
);

export default PromoDisplayer;
